import { render, staticRenderFns } from "./nolearn.vue?vue&type=template&id=18090e8f&scoped=true&"
import script from "./nolearn.vue?vue&type=script&lang=js&"
export * from "./nolearn.vue?vue&type=script&lang=js&"
import style0 from "./nolearn.vue?vue&type=style&index=0&id=18090e8f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18090e8f",
  null
  
)

export default component.exports